import {
  assetConstants
} from "./chunk-4DFBUXHM.js";

// src/tickMath.ts
import BigNumber from "bignumber.js";
var MIN_TICK = -887272;
var MAX_TICK = -MIN_TICK;
var FULL_TICK_RANGE = { start: MIN_TICK, end: MAX_TICK };
var tickToRate = (tick, baseAsset) => {
  const baseRate = new BigNumber(1.0001 ** tick);
  const rateDecimals = assetConstants.Usdc.decimals - assetConstants[baseAsset].decimals;
  return baseRate.shiftedBy(-rateDecimals).toNumber();
};
var rateToTick = (rate, baseAsset) => {
  const rateDecimals = assetConstants.Usdc.decimals - assetConstants[baseAsset].decimals;
  const rawRate = new BigNumber(rate).shiftedBy(rateDecimals);
  let tick = Math.log(rawRate.toNumber()) / Math.log(1.0001);
  tick = Math.round(tick * 1e6) / 1e6;
  tick = Math.floor(tick);
  return Math.max(MIN_TICK, Math.min(tick, MAX_TICK));
};
var sqrtPriceX96ToPrice = (amount) => new BigNumber(amount).div(new BigNumber(2).pow(96)).pow(2);
var priceX128ToPrice = (amount) => new BigNumber(amount).div(new BigNumber(2).pow(128));
export {
  FULL_TICK_RANGE,
  MAX_TICK,
  MIN_TICK,
  priceX128ToPrice,
  rateToTick,
  sqrtPriceX96ToPrice,
  tickToRate
};
